module.exports = __webpack_public_path__ + "static/media/kraken.432c955f.svg";